import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Image from 'components/_new/ui/Image/Image'

import s from './DefaultExtraVolume.scss'


const ProductVolumesDefaultExtraVolume = ({ className, item, index, isActive, brand, onSelect, withMicrodata, testId }) => {
  const { id, img, price, inStock } = item

  const volumeClassName = cx(s.volume, {
    [s.active]: isActive,
  })

  return (
    <div
      key={id}
      className={cx(className)}
      {...withMicrodata && {
        itemProp: 'offers',
        itemScope: true,
        itemType: 'http://schema.org/Offer',
      }}
    >
      <button
        className={volumeClassName}
        type="button"
        data-testid={testId}
        onClick={() => onSelect(index)}
      >
        <div className={s.volumePreview}>
          <Image
            src={img}
            alt="volume"
            h={50}
            x2
            {...withMicrodata && { itemProp: 'image' }}
          />
        </div>
        {
          withMicrodata && (
            <span style={{ display: 'none' }}>
              <span itemProp="sku">{id}</span>
              <span itemProp="priceCurrency">USD</span>
              <span itemProp="price">{price / 100}</span>
              <span itemProp="category">{brand}</span>
              <link
                itemProp="availability"
                href={`http://schema.org/${inStock ? 'InStock' : 'OutOfStock'}`}
              />
            </span>
          )
        }
      </button>
    </div>
  )
}

ProductVolumesDefaultExtraVolume.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    price: PropTypes.number,
    inStock: PropTypes.bool,
  }),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  brand: PropTypes.string,
  onSelect: PropTypes.func,
  withMicrodata: PropTypes.bool,
  testId: PropTypes.string,
}


export default ProductVolumesDefaultExtraVolume
